import { render, staticRenderFns } from "./Policy.vue?vue&type=template&id=145a367e&scoped=true"
import script from "./Policy.vue?vue&type=script&lang=ts"
export * from "./Policy.vue?vue&type=script&lang=ts"
import style0 from "./Policy.vue?vue&type=style&index=0&id=145a367e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "145a367e",
  null
  
)

export default component.exports